var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(!_vm.isLoaded),expression:"!isLoaded",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"main"},[(_vm.loginState == 'signedin')?_c('Layout'):_c('Login')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }